export default __webpack_public_path__ + "static/media/loginBG.35de3219.jpeg";